<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'RootProject'
}
</script>

<style>

</style>
